import React, { FC } from 'react'

import { Text } from 'mf-ui-components'

import MinusIcon from '../../../../images/minusIcon.svg'
import PlusIcon from '../../../../images/plusIcon.svg'
import { Button, TimeFrameWrapper, ValueWrapper } from './TimeFrame.styles'
import rawlang, * as l10n from '../../../../utils/l10n'

const lang = rawlang as 'en' | 'it'

type Props = {
  options?: { label: string; value: number }[]
  onChange: (value: number) => void
  value?: number
}

export const TimeFrame: FC<Props> = ({ options = [], onChange, value = 0 }) => {
  const changeTimeFrame = (increment: number) => {
    const index = options.findIndex(item => item.value === value)

    const timeFrameIndex = (index + increment + options.length) % options.length

    onChange(options[timeFrameIndex].value)
  }

  return (
    <TimeFrameWrapper>
      <Button onClick={() => changeTimeFrame(-1)}>
        <img src={MinusIcon} alt="Decrease time frame" />
      </Button>
      <ValueWrapper>
        <Text el="span" styleName="bodyRegular">
          {value}&nbsp;{l10n.expected_performance.years[lang]}
        </Text>
      </ValueWrapper>
      <Button onClick={() => changeTimeFrame(+1)}>
        <img src={PlusIcon} alt="Increase time frame" />
      </Button>
    </TimeFrameWrapper>
  )
}
